// extracted by mini-css-extract-plugin
var _1 = "styles-module__popper___jPfa_";
export { _1 as "popper" }
